// Mock data for SM Engineering website

export const businessInfo = {
  name: "SM Autolocksmith & Diagnostics",
  tagline: "Professional Auto Locksmith Services",
  phone: "07584 066850",
  location: "Ely, Cambridgeshire, United Kingdom",
  serviceArea: "Cambridge, King's Lynn, Peterborough, Bury St Edmunds, Norwich, March & Surrounding Areas",
  coordinates: { lat: 52.3986, lng: 0.2622 }, // Ely, Cambridgeshire
  email: "info@smengineering.co.uk",
  hours: "24/7 Emergency Callout Available"
};

export const services = [
  {
    id: "key-services",
    title: "Key Programming & Replacement",
    shortDesc: "Lost your keys? We provide fast, professional key cutting and programming",
    icon: "Key",
    image: "https://images.unsplash.com/photo-1533558701576-23c65e0272fb",
    features: [
      "All Makes & Models",
      "Transponder Key Programming",
      "Remote Key Fob Replacement",
      "Spare Key Creation",
      "Key Blade Cutting",
      "Same Day Service Available"
    ],
    price: ""
  },
  {
    id: "lockouts",
    title: "Emergency Lockout Service",
    shortDesc: "Locked out of your vehicle? Our expert team responds fast",
    icon: "LockOpen",
    image: "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767",
    features: [
      "Non-Destructive Entry",
      "24/7 Emergency Response",
      "All Vehicle Types",
      "Fast Response Times",
      "Fully Insured Service",
      "Competitive Pricing"
    ],
    price: "From £60"
  },
  {
    id: "emergency",
    title: "24/7 Emergency Callout",
    shortDesc: "Round-the-clock support when you need it most",
    icon: "Phone",
    image: "https://images.unsplash.com/photo-1517524206127-48bbd363f3d7",
    features: [
      "Available 24/7/365",
      "Rapid Response",
      "Mobile Service",
      "No Call-Out Charge",
      "Expert Technicians",
      "Transparent Pricing"
    ],
    price: ""
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Roberts",
    location: "Cambridge",
    rating: 5,
    text: "Fantastic diagnostic service! They identified the fault with my car's electrical system quickly and got it sorted. Very professional and reasonably priced.",
    service: "Vehicle Diagnostics"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    location: "Peterborough",
    rating: 5,
    text: "Lost my car keys on holiday and SM Engineering came out the same day. Professional, quick, and reasonably priced. Thank you!",
    service: "Key Replacement"
  },
  {
    id: 3,
    name: "David Thompson",
    location: "King's Lynn",
    rating: 5,
    text: "Locked myself out at 2am - they arrived within 30 minutes and got me back in without any damage. Lifesavers!",
    service: "Emergency Lockout"
  }
];

export const mockInquiries = [];

// Mock inquiry submission
export const submitInquiry = async (inquiryData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const inquiry = {
        id: `INQ${Date.now()}`,
        ...inquiryData,
        status: "pending",
        createdAt: new Date().toISOString()
      };
      mockInquiries.push(inquiry);
      resolve(inquiry);
    }, 1000);
  });
};
